import { render, staticRenderFns } from "./localisation.vue?vue&type=template&id=40c0b606&"
import script from "./localisation.vue?vue&type=script&lang=js&"
export * from "./localisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports